<template>
  <div>
    <!-- 装箱界面 -->
    <el-dialog :title="$t('message.encasementInterface')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1328px" center>
      <div class="content">
        <!-- oneCasePack: '每一箱装箱数', -->
        <div class="head-title">
          <!-- 当前选中箱数： -->
          <span>
            {{ $t("message.selectBoxNum") }}：
            <span class="color" style="margin-right: 70px">{{ detail.box_count }}</span>
          </span>
          <!--选中箱号  -->
          <span>{{ $t("message.selectBoxes") }}：</span>
          <div class="selectBox" v-if="detail.box_no_set">
            <el-tooltip class="item" effect="dark" :content="detail.box_no_set.join(',')" placement="top-start">
              <span class="color">{{ detail.box_no_set.join(',') }}</span>
            </el-tooltip>
          </div>
        </div>
        <div class="table">
          <ol>
            <!-- 库位 -->
            <li class="flex15">{{ $t("message.location") }}</li>
            <!-- 订单号 -->
            <li class="flex15">{{ $t("message.orderNumber") }}</li>
            <!-- 番号 -->
            <li class="flex05">{{ $t("message.mash") }}</li>
            <!-- 照片 -->
            <li>{{ $t("message.pic") }}</li>
            <!-- 商品属性 -->
            <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
            <!-- 交易号/物流号 -->
            <li class="flex2">{{ $t("message.transactionNumberLogisticsNumber") }}</li>
            <!-- 在库数量 -->
            <li>{{ $t("message.inStockQuantity") }}</li>
            <!-- 转库数量 -->
            <li>{{ $t("message.transferQuantity") }}</li>
            <!-- 每一箱装箱数 -->
            <li>{{ $t("message.oneCasePack") }}</li>

          </ol>
          <ul v-for="(item, index) in list" :key="index">
            <!-- 库位 -->
            <li class="flex15">
              <div>
                <p>{{ item.grid_number.split("】-")[0] }}】-</p>
                <p style="color: #fa5058">
                  {{ item.grid_number.split("】-")[1] }}
                </p>
              </div>

            </li>
            <!-- 订单号 -->
            <li class="flex15">
              <div>
                <el-link type="primary" :underline="false" :href="'/#/orderPaymentDetail?order_sn=' + item.order_sn"
                  target="_blank">
                  {{ item.order_sn }}
                </el-link>
              </div>
            </li>
            <li class="flex05">{{ item.sorting }}</li>
            <!-- 照片 -->
            <li>
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="item.pic" alt="" style="width: 300px; height: 300px" />
                <a :href="item.link.goods_url" slot="reference" target="_blank">
                  <el-image :src="item.pic" style="width: 60px; height: 60px; border-radius: 4px">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                </a>
              </el-popover>
            </li>
            <!-- 商品属性 -->
            <li class="flex15">
              <div class="attribute">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                      style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!-- 交易号/物流号 -->
            <li class="flex2">
              <div class="template">
                <p>JY:{{ item.purchase_no }}</p>
                <p v-for="(express_no, express_index) in item
                  .express_no" :key="express_index">
                  WL{{ express_index + 1 }}：{{ express_no }}
                </p>
              </div>
            </li>
            <!-- 在库数量 -->
            <li>
              {{ item.stock_num }}
            </li>
            <!-- 转库数量 -->
            <li>{{ item.this_await_num }}</li>
            <!-- 每一箱装箱数 -->
            <li>
              <el-input v-model="item.per_box_num" onfocus="this.select()"
                @input="batchMaxItemNum(item, index)"></el-input>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    move_sn: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialogVisible: false,
      box_id_set: [],
      list: [],
      detail: {
      }
    };
  },
  computed: {

  },
  created() { },
  methods: {
    // 数据预览
    intoBoxPreview(move_sn, move_detail_ids, box_id_set) {
      this.box_id_set = box_id_set
      let datas = {
        move_sn,
        move_detail_ids,
        box_id_set,
      };
      this.$api.inventoryTransferApi.intoBoxPreview(datas).then((res) => {
        this.list = res.data.details;
        this.detail = res.data

      });
    },
    // 保存
    save() {
      let datas = {
        move_sn: this.move_sn,
        box_id_set: this.box_id_set,
        list: [],
      };
      for (let i = 0; i < this.list.length; i++) {

        if (this.list[i].per_box_num == 0 || !this.list[i].per_box_num)
          return this.$message.error("请输入每一箱装箱数");
        datas.list.push({
          num: this.list[i].per_box_num,
          move_detail_id: this.list[i].move_detail_id,
        });
      }
      this.$api.inventoryTransferApi.intoBox(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$store.dispatch("moveDetail", { move_sn: this.move_sn, });
        this.$store.dispatch("transferOrdeBoxList", { move_sn: this.move_sn, });
        this.$parent.checked = false
        this.$parent.handleCheckedChange()
      });
    },
    // 计算装箱最大数
    batchMaxItemNum(data, i) {
      if (data.per_box_num !== '' && data.per_box_num !== null) {
        data.per_box_num = data.per_box_num.replace(/\D/g, '');
        if (data.per_box_num * this.detail.box_count > data.this_await_num) {
          data.per_box_num = data.this_await_num / this.detail.box_count
        }
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.content {

  padding: 24px;
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;

  .head-title {
    border-radius: 4px;
    font-size: 16px;
    padding: 0 24px;

    display: flex;
    overflow: hidden;

    .selectBox {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .color {
      color: #333;
      font-weight: bold;
    }
  }

  .table {
    margin-top: 20px;

    ol {
      height: 50px;
    }

    .flex05 {
      flex: 0.5;
    }

    .flex15 {
      flex: 1.5;
    }

    .flex2 {
      flex: 2.5;
    }

    li {
      margin-right: 5px;

      &:nth-last-child(1) {
        margin: 0;
      }

      /deep/.el-input__inner {
        padding: 0;
        text-align: center;
      }
    }

    .attribute {
      width: 100%;
      text-align: left;
      max-height: 80px;

      padding: 10px;
    }

    .template {
      width: 100%;

      .row {
        display: flex;
        margin-bottom: 5px;

        &:nth-last-child(1) {
          margin: 0;
        }

        .jy {
          flex: 1;
          margin-right: 5px;
        }

        .location {
          flex: 1.5;
          display: flex;

          span {
            &:nth-child(1) {
              flex: 4;
              margin-right: 5px;
            }

            &:nth-child(2) {
              color: #fa5058;
              flex: 1;
              display: flex;
              align-items: center;
            }
          }
        }
      }
    }
  }
}
</style>